import { useEffect, useState } from 'react'
import { storageGet, storageSet } from '@/lib/storage'
import { THEME_STORAGE_KEY } from '@/lib/constants'

export type Theme = 'dark' | 'light'

function getInitialTheme(): Theme {
  const saved = storageGet<Theme>(THEME_STORAGE_KEY)
  if (saved === 'dark' || saved === 'light') return saved
  if (typeof window !== 'undefined' && window.matchMedia) {
    return window.matchMedia('(prefers-color-scheme: light)').matches ? 'light' : 'dark'
  }
  return 'dark'
}

function applyTheme(theme: Theme) {
  document.documentElement.setAttribute('data-theme', theme)
}

export function useTheme() {
  const [theme, setThemeState] = useState<Theme>(getInitialTheme)

  useEffect(() => {
    applyTheme(theme)
  }, [theme])

  const setTheme = (next: Theme) => {
    setThemeState(next)
    storageSet(THEME_STORAGE_KEY, next)
    applyTheme(next)
  }

  const toggle = () => setTheme(theme === 'dark' ? 'light' : 'dark')

  return { theme, setTheme, toggle }
}
